import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonService } from '../common-service.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements AfterViewInit {
  navLarge = false;
  isLoggedIn = true;

  constructor(private commonService: CommonService) { }

  ngAfterViewInit() { }

  getCurrentNav(val: boolean) {
    // this.navLarge = val;
  }
}
